export const SET_AUTH_TOKEN = "auth/SET_AUTH_TOKEN";
export const SET_HAS_CHECKED_AUTH = "auth/SET_HAS_CHECKED_AUTH";
export const SET_PROFILE = "auth/SET_PROFILE";

export const LOGOUT = "auth/LOGOUT";
